import { Editor } from 'slate';

function getClosestWordRange(editor, selection) {
  const leaf = Editor.leaf(editor, selection);
  const [{
    text
  }] = leaf;
  const {
    offset,
    path
  } = selection.anchor;
  const [left, right] = getClosestWordOffsets(text, offset);
  return {
    anchor: {
      path,
      offset: left
    },
    focus: {
      path,
      offset: right
    }
  };
}
function getClosestWordOffsets(text, cursorOffset) {
  let left = text.slice(0, cursorOffset).search(/\S+$/);
  if (left < 0) {
    left = cursorOffset;
  }
  let right = text.slice(cursorOffset).search(/\s/);
  if (right < 0) {
    right = text.length;
  } else {
    right += cursorOffset;
  }
  return [left, right];
}

export { getClosestWordRange };
